/**
 * Raíz de la aplicación: rutas y estructura común (encabezado + sesión obligatoria).
 *
 *   /           Tablero
 *   /cuenta     Mi cuenta (tokens de API)
 *   /docs/*     Documentación (carpeta docs/ incluida al compilar)
 *   /personas   Administración de personas (solo administradores)
 *   /configuracion  Configuración por secciones, hoy nombres de prioridades (solo administradores)
 */
import { Navigate, Route, Routes } from 'react-router';
import { BarraCargaPagina } from './componentes/BarraCargaPagina';
import { Encabezado } from './componentes/Encabezado';
import { GuardiaDeSesion } from './features/auth/sesion';
import { PaginaConfiguracion } from './paginas/PaginaConfiguracion';
import { PaginaCuenta } from './paginas/PaginaCuenta';
import { PaginaDocs } from './paginas/PaginaDocs';
import { PaginaPersonas } from './paginas/PaginaPersonas';
import { PaginaTablero } from './paginas/PaginaTablero';

export function App() {
  return (
    <GuardiaDeSesion>
      <BarraCargaPagina />
      <Encabezado />
      <Routes>
        <Route path="/" element={<PaginaTablero />} />
        <Route path="/cuenta" element={<PaginaCuenta />} />
        <Route path="/personas" element={<PaginaPersonas />} />
        <Route path="/configuracion" element={<PaginaConfiguracion />} />
        <Route path="/docs/*" element={<PaginaDocs />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </GuardiaDeSesion>
  );
}
